/* eslint-disable */

import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  updateDoc,
  doc,
  setDoc,
  addDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import { Upload, CheckCircle, Clock } from "lucide-react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const IdentityVerification = () => {
  const account = useSelector((state) => state.AccountReducer);
  const [identityData, setIdentityData] = useState({
    cardType: "",
    cardNumber: "",
    selfieWithId: null,
    idImages: [],
  });
  const [uploadingIdentity, setUploadingIdentity] = useState(false);
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const { t } = useTranslation();

  const handleIdentitySubmit = async (e) => {
    e.preventDefault();

    if (
      !identityData.cardType ||
      !identityData.cardNumber ||
      !identityData.selfieWithId ||
      identityData.idImages.length === 0
    ) {
      Swal.fire({
        icon: "warning",
        title: t(
          "AccountSettings.identityVerification.submitFeedback.warnings.title"
        ),
        text: t(
          "AccountSettings.identityVerification.submitFeedback.warnings.message"
        ),
        confirmButtonColor: "#9b59bf",
      });
      return;
    }

    setUploadingIdentity(true);

    try {
      const selfieUrl = await uploadImage(identityData.selfieWithId, "selfie");
      const idImageUrls = [];
      for (let i = 0; i < identityData.idImages.length; i++) {
        if (i > 0) await sleep(1000);
        const url = await uploadImage(identityData.idImages[i]);
        idImageUrls.push(url);
      }

      const verificationData = {
        user: account.user,
        cardType: identityData.cardType,
        cardNumber: identityData.cardNumber,
        selfieWithIdUrl: selfieUrl,
        idImageUrls: idImageUrls,
        status: 1,
        createdAt: new Date(),
        updatedAt: new Date(),
      };

      const q = query(
        collection(db, "identity_verification"),
        where("user", "==", account.user),
        where("status", "==", 2)
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const docRef = snapshot.docs[0].ref;
        await updateDoc(docRef, verificationData);
      } else {
        await addDoc(collection(db, "identity_verification"), verificationData);
      }
      const updatedAccountData = {
        ...account,
        identityVerification: {
          cardType: identityData.cardType,
          cardNumber: identityData.cardNumber,
          status: 1,
        },
      };

      await setDoc(doc(db, "account", account.id), updatedAccountData);

      Swal.fire({
        icon: "success",
        title: t(
          "AccountSettings.identityVerification.submitFeedback.success.title"
        ),
        text: t(
          "AccountSettings.identityVerification.submitFeedback.success.message"
        ),
        confirmButtonText: t(
          "AccountSettings.identityVerification.submitFeedback.success.button"
        ),
        confirmButtonColor: "#9b59bf",
      });

      // إعادة تعيين النموذج
      setIdentityData({
        cardType: "",
        cardNumber: "",
        selfieWithId: null,
        idImages: [],
      });
    } catch (error) {
      console.error("خطأ في رفع بيانات التحقق:", error);
      Swal.fire({
        icon: "error",
        title: t(
          "AccountSettings.identityVerification.submitFeedback.error.title"
        ),
        text: t(
          "AccountSettings.identityVerification.submitFeedback.error.message"
        ),
        confirmButtonColor: "#9b59bf",
      });
    } finally {
      setUploadingIdentity(false);
    }
  };

  const handleFileChange = (e, type) => {
    const files = Array.from(e.target.files);
    const filesUpdated = [...files, ...identityData.idImages];

    if (type === "selfie") {
      setIdentityData((prev) => ({ ...prev, selfieWithId: files[0] }));
    } else if (type === "id") {
      setIdentityData((prev) => ({ ...prev, idImages: filesUpdated }));
    }
  };
  const uploadImage = async (file) => {
    const dataImage = new FormData();
    dataImage.append("upload", file, `${Date.now()}-${file.name}`);

    const response = await axios.post(
      "https://octopus-app-i4ylg.ondigitalocean.app/upload",
      dataImage,
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );

    return response.data.url;
  };

  if (account.productMode !== "digital") return null;

  if (account.identityVerification?.status === 3) {
    return (
      <div className="bg-green-50 dark:!bg-[#181919] rounded-xl shadow-sm p-6 border border-green-200 dark:!border-[#3c3a3d] mb-6">
        <div className="flex items-center mb-4">
          <CheckCircle
            size={20}
            className="text-green-600 dark:!text-green-400 ml-2"
          />
          <h3 className="text-lg font-semibold text-green-800 dark:!text-green-300">
            {t("AccountSettings.identityVerification.verified.title")}
          </h3>
        </div>
        <div className="text-green-700 dark:!text-green-400">
          <p className="mb-2">
            {t("AccountSettings.identityVerification.verified.message")}
          </p>
          <p className="text-sm">
            {t(
              "AccountSettings.identityVerification.verified.documentInfo.type"
            )}
            : {account.identityVerification.cardType} |{" "}
            {t(
              "AccountSettings.identityVerification.verified.documentInfo.number"
            )}
            : {account.identityVerification.cardNumber}
          </p>
        </div>
      </div>
    );
  }

  if (account.identityVerification?.status === 1) {
    return (
      <div className="bg-yellow-50 dark:!bg-[#181919] rounded-xl shadow-sm p-6 border border-yellow-200 dark:!border-[#3c3a3d] mb-6">
        <div className="flex items-center mb-4">
          <Clock
            size={20}
            className="text-yellow-600 dark:!text-yellow-400 ml-2"
          />
          <h3 className="text-lg font-semibold text-yellow-800 dark:!text-yellow-300">
            {t("AccountSettings.identityVerification.review.title")}
          </h3>
        </div>
        <div className="text-yellow-700 dark:!text-yellow-400">
          <p className="mb-2">
            {t("AccountSettings.identityVerification.review.message")}
          </p>
          <p className="text-sm">
            {t("AccountSettings.identityVerification.review.documentInfo.type")}
            : {account.identityVerification.cardType} |{" "}
            {t(
              "AccountSettings.identityVerification.review.documentInfo.number"
            )}
            : {account.identityVerification.cardNumber}
          </p>
          <p className="text-sm mt-2">
            {t("AccountSettings.identityVerification.review.note")}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-xl p-6 mb-6 bg-white dark:!bg-[#181919] border border-transparent dark:!border-[#3c3a3d]">
      <div className="flex items-center mb-6">
        <Upload size={20} className="text-[#9e68ba] ml-2" />
        <h3 className="text-lg font-semibold text-gray-800 dark:!text-white">
          {t("AccountSettings.identityVerification.title")}
        </h3>
      </div>

      {account.identityVerification?.status === 2 && (
        <h2 className="text-sm text-red-500">
          {t("AccountSettings.identityVerification.status.rejected")}
        </h2>
      )}

      <form onSubmit={handleIdentitySubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {/* Type de document */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-[#9e68ba] mb-2">
              {t(
                "AccountSettings.identityVerification.form.fields.documentType.label"
              )}
            </label>
            <select
              value={identityData.cardType}
              onChange={(e) =>
                setIdentityData((prev) => ({
                  ...prev,
                  cardType: e.target.value,
                }))
              }
              className="bg-white dark:!bg-[#141414] border border-gray-300 dark:!border-[#3c3a3d] text-gray-900 dark:!text-white text-sm rounded-lg block w-full py-3 px-3 focus:ring-purple-200 focus:border-purple-500"
              required
            >
              <option value="">
                {t(
                  "AccountSettings.identityVerification.form.fields.documentType.placeholder"
                )}
              </option>
              <option value="CN">
                {t(
                  "AccountSettings.identityVerification.form.fields.documentType.options.CN"
                )}
              </option>
              <option value="permis">
                {t(
                  "AccountSettings.identityVerification.form.fields.documentType.options.permis"
                )}
              </option>
              <option value="passeport">
                {t(
                  "AccountSettings.identityVerification.form.fields.documentType.options.passeport"
                )}
              </option>
            </select>
          </div>

          {/* Numéro du document */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-[#9e68ba] mb-2">
              {t(
                "AccountSettings.identityVerification.form.fields.documentNumber.label"
              )}
            </label>
            <input
              type="text"
              value={identityData.cardNumber}
              onChange={(e) =>
                setIdentityData((prev) => ({
                  ...prev,
                  cardNumber: e.target.value,
                }))
              }
              className="bg-white dark:!bg-[#141414] border border-gray-300 dark:!border-[#3c3a3d] text-gray-900 dark:!text-white text-sm rounded-lg block w-full py-3 px-3 focus:ring-purple-200 focus:border-purple-500"
              placeholder={t(
                "AccountSettings.identityVerification.form.fields.documentNumber.placeholder"
              )}
              required
            />
          </div>

          {/* Selfie avec document */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-[#9e68ba] mb-2">
              {t(
                "AccountSettings.identityVerification.form.fields.selfie.label"
              )}
            </label>
            <div className="border-2 border-dashed border-gray-300 dark:!border-[#3c3a3d] rounded-lg p-4 text-center hover:border-[#9e68ba] transition-colors">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, "selfie")}
                className="hidden"
                id="selfie-upload"
                required
              />

              {identityData.selfieWithId ? (
                <div className="relative">
                  <img
                    src={URL.createObjectURL(identityData.selfieWithId)}
                    alt={t("ui.selfieDocument")}
                    className="max-w-full max-h-48 mx-auto rounded-lg shadow-md"
                  />
                  <div className="mt-3 flex items-center justify-center gap-2">
                    <p className="text-sm text-green-600 dark:!text-green-400 font-medium">
                      ✓ {identityData.selfieWithId.name}
                    </p>
                    <label
                      htmlFor="selfie-upload"
                      className="text-sm text-[#9e68ba] hover:text-[#8a5a9f] cursor-pointer underline"
                    >
                      {t(
                        "AccountSettings.identityVerification.form.fields.selfie.changePhoto"
                      )}
                    </label>
                  </div>
                </div>
              ) : (
                <label htmlFor="selfie-upload" className="cursor-pointer block">
                  <Upload
                    size={32}
                    className="mx-auto text-gray-400 dark:!text-gray-300 mb-2"
                  />
                  <p className="text-sm text-gray-600 dark:!text-gray-300">
                    {t(
                      "AccountSettings.identityVerification.form.fields.selfie.placeholder"
                    )}
                  </p>
                  <p className="text-xs text-gray-400 dark:!text-gray-500 mt-1">
                    {t(
                      "AccountSettings.identityVerification.form.fields.selfie.hint"
                    )}
                  </p>
                </label>
              )}
            </div>
          </div>

          {/* Images de la pièce d'identité */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-[#9e68ba] mb-2">
              {t(
                "AccountSettings.identityVerification.form.fields.idImages.label"
              )}
            </label>

            <div className="flex flex-wrap gap-4">
              {identityData.idImages.map((image, index) => (
                <div key={index} className="relative group w-32 h-32">
                  <div className="w-full h-full border-2 border-gray-200 dark:!border-[#3c3a3d] rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all">
                    <img
                      src={URL.createObjectURL(image)}
                      alt={t("ui.documentNumber", { value0: (index + 1) })}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <button
                    onClick={() => {
                      const newImages = identityData.idImages.filter(
                        (_, i) => i !== index
                      );
                      setIdentityData((prev) => ({
                        ...prev,
                        idImages: newImages,
                      }));
                    }}
                    className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors shadow-lg opacity-0 group-hover:opacity-100"
                  >
                    <svg
                      className="w-3 h-3"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              ))}

              {/* Ajout nouvelle image */}
              <div className="w-32 h-32">
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => handleFileChange(e, "id")}
                  className="hidden"
                  id="id-upload-add"
                />
                <label
                  htmlFor="id-upload-add"
                  className="w-full h-full border-2 border-dashed border-[#9e68ba] rounded-xl flex flex-col items-center justify-center cursor-pointer hover:border-[#8a5a9f] hover:bg-[#9e68ba]/5 transition-all group"
                >
                  <div className="w-8 h-8 bg-[#9e68ba] rounded-full flex items-center justify-center mb-2 group-hover:bg-[#8a5a9f] transition-colors">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <span className="text-xs text-[#9e68ba] font-medium text-center leading-tight">
                    {t(
                      "AccountSettings.identityVerification.form.fields.idImages.addPhoto"
                    )}
                  </span>
                </label>
              </div>
            </div>

            <p className="text-xs text-gray-500 dark:!text-gray-400 mt-3 flex items-center">
              <svg
                className="w-4 h-4 mr-1 text-blue-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                />
              </svg>
              {t(
                "AccountSettings.identityVerification.form.fields.idImages.hint"
              )}
            </p>
          </div>
        </div>

        {/* Bouton submit */}
        <div className="flex justify-end">
          <button
            type="submit"
            className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:pointer-events-none"
            disabled={uploadingIdentity}
          >
            {uploadingIdentity ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                <span className="mr-1">
                  {t(
                    "AccountSettings.identityVerification.form.submit.loading"
                  )}
                </span>
              </>
            ) : (
              <>
                <Upload size={18} />
                <span className="mr-1">
                  {t("AccountSettings.identityVerification.form.submit.label")}
                </span>
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default IdentityVerification;
